import { render, staticRenderFns } from "./ConfigAuthenticationDevice.vue?vue&type=template&id=22e5b47e&scoped=true"
import script from "./ConfigAuthenticationDevice.vue?vue&type=script&lang=js"
export * from "./ConfigAuthenticationDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5b47e",
  null
  
)

export default component.exports